import type { Timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Converts a JavaScript Date to a protobuf Timestamp.
 *
 * @param date - The JavaScript Date to convert
 * @returns protobuf Timestamp object
 *
 * @example
 * ```typescript
 * const timestamp = dateToTimestamp(new Date());
 * console.log(timestamp.seconds); // Unix timestamp in seconds
 * ```
 */
export function dateToTimestamp(date: Date): Timestamp {
  const milliseconds = date.getTime();
  return {
    seconds: BigInt(Math.floor(milliseconds / 1000)),
    nanos: (milliseconds % 1000) * 1000000,
    $typeName: "google.protobuf.Timestamp",
  };
}

/**
 * Converts a protobuf Timestamp to a JavaScript Date.
 *
 * @param timestamp - The protobuf Timestamp to convert
 * @returns JavaScript Date object
 *
 * @example
 * ```typescript
 * const date = timestampToDate(response.createdAt);
 * console.log(date.toISOString()); // "2024-01-01T12:00:00.000Z"
 * ```
 */
export function timestampToDate(timestamp: Timestamp): Date {
  const milliseconds = Number(timestamp.seconds) * 1000 + Math.floor(timestamp.nanos / 1000000);
  return new Date(milliseconds);
}
